import styled from 'styled-components'

export const AlertWrapper = styled.div`
  .mantine-Alert-root {
    background: ${({ theme, type }) =>
      type === 'danger'
        ? theme.designSystem.background.dangerTransparent
        : theme.alerta.warning.background};
  }

  .mantine-Alert-message,
  .mantine-Alert-closeButton {
    color: ${({ theme }) => theme.cor9}!important;
  }

  .mantine-Alert-title {
    color: ${({ theme, type }) =>
      type === 'danger'
        ? theme.designSystem.background.danger
        : theme.alerta.warning.color};
  }

  .mantine-Alert-icon {
    color: ${({ theme, type }) =>
      type === 'danger'
        ? theme.designSystem.background.danger
        : theme.alerta.warning.color};
    display: flex;
    align-items: center;
    justify-content: center;
  }

  svg > path {
    fill: ${({ theme, type }) =>
      type === 'danger'
        ? theme.designSystem.background.danger
        : theme.alerta.warning.color};
  }
`
